import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 18px;
  min-width: 340px;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Label = styled.label`
  font-weight: 600;
  color: #34574A;
`;

const Input = styled.input`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
`;

const Select = styled.select`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
`;

const TextArea = styled.textarea`
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 1rem;
  min-height: 90px;
  resize: vertical;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

const ActionButton = styled.button`
  background: #34574A;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 18px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #27443a;
  }
`;

const StatusRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const StatusButton = styled.button`
  background: ${props => props.active ? '#22c55e' : '#c62828'};
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
  opacity: ${props => props.active ? 1 : 0.6};
  &:hover {
    opacity: 0.85;
  }
`;

const FaqForm = ({ onSubmit, onCancel, initialData, tipos }) => {
  const [tipoFAQ, setTipoFAQ] = useState(initialData?.tipoFAQ || (tipos?.[0]?.codigoFAQTIPO || ''));
  const [perguntaFAQ, setPerguntaFAQ] = useState(initialData?.perguntaFAQ || '');
  const [respostaFAQ, setRespostaFAQ] = useState(initialData?.respostaFAQ || '');
  const [ativoFAQ, setAtivoFAQ] = useState(initialData?.ativoFAQ === 0 ? 0 : 1);

  useEffect(() => {
    if (!initialData && tipos && tipos.length > 0) {
      setTipoFAQ(tipos[0].codigoFAQTIPO);
    }
  }, [tipos, initialData]);

  const handleSubmit = e => {
    e.preventDefault();
    onSubmit({ tipoFAQ: Number(tipoFAQ), perguntaFAQ, respostaFAQ, ativoFAQ });
  };

  return (
    <FormContainer onSubmit={handleSubmit}>
      <Field>
        <Label>Tipo</Label>
        <Select value={tipoFAQ} onChange={e => setTipoFAQ(e.target.value)} required>
          {tipos && tipos.map(tipo => (
            <option key={tipo.codigoFAQTIPO} value={tipo.codigoFAQTIPO}>{tipo.nomeFAQTIPO}</option>
          ))}
        </Select>
      </Field>
      <Field>
        <Label>Pergunta</Label>
        <Input value={perguntaFAQ} onChange={e => setPerguntaFAQ(e.target.value)} required />
      </Field>
      <Field>
        <Label>Resposta</Label>
        <TextArea value={respostaFAQ} onChange={e => setRespostaFAQ(e.target.value)} required />
      </Field>
      <Field>
        <Label>Status</Label>
        <StatusRow>
          <StatusButton
            type="button"
            active={ativoFAQ === 1}
            onClick={() => setAtivoFAQ(1)}
          >Ativo</StatusButton>
          <StatusButton
            type="button"
            active={ativoFAQ === 0}
            onClick={() => setAtivoFAQ(0)}
          >Inativo</StatusButton>
        </StatusRow>
      </Field>
      <ButtonRow>
        <ActionButton type="button" style={{background:'#bbb',color:'#222'}} onClick={onCancel}>Cancelar</ActionButton>
        <ActionButton type="submit">Salvar</ActionButton>
      </ButtonRow>
    </FormContainer>
  );
};

export default FaqForm;
